<template>
  <ion-page>
    <master-layout pageTitle="ویرایش انبار">
      <ion-card>
        <ion-card-content>
          <Loading :is="!invoiceLoaded" v-if="!invoiceLoaded"></Loading>
          <div v-if="invoiceLoaded">
            <div v-if="invoice">
              <div>
                <strong>شماره فاکتور: </strong>
                <span> {{ invoice.draft_number }}</span>
              </div>
              <hr/>
              <div>
                <strong>شماره حواله: </strong>
                <span> {{ invoice.draft_number }}</span>
              </div>
              <br/>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>محصول</th>
                    <th>ویژگی</th>
                    <th>قیمت خرید</th>
                    <th>تعداد</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in invoice.items" :key="item._id">
                    <td>{{item.product_title}}</td>
                    <td>{{item.attr_str}}</td>
                    <td>{{item.buy_price}}</td>
                    <td>{{item.quantity}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";

export default {
  data()
  {
    return {
      id: null,
      invoiceLoaded: false,
      invoice: null,
      error: null
    };
  },
  async created()
  {
    this.id = this.$route.params.invoiceId;
    const result = await this.getInvoice(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.invoiceLoaded = true;
        this.invoice = result.invoice;
      }
      else
      {
        this.invoiceLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.invoiceLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  components: {
    Loading,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("warehouse", {
      getInvoice: 'getInvoice'
    })
  }
};

</script>

<style scoped>

</style>